import React, { useEffect, useRef, useState } from 'react';
import IsecNavbar from './IsecNavbar';
import './pages-css/Status.css';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import { changeStatus } from '../../REDUX_ISECURION/status/statusActions';
import { setProjectData } from '../../REDUX_ISECURION/statusPage/statuspageAction';
import CustomSelect from './Custom_Functions/CustomSelect';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { useAuth } from '../../Context/UserContext';
import { updateProjectStatus } from '../../REDUX_ISECURION/retestStatus/retestAction';
import IsecNavbar2 from './IsecNavbar2';
import { url } from '../../constants/url';
import GenerateReportFiles from './Generate Report/ReportDownload';
import ClientNavbar1 from '../../Client-components/Pages/ClientNavbar1';
import ProjectHeader from '../Modal/ProjectHeader'
import ProjectTabContent from '../Modal/ProjectTabContent'

const Status = ({ setStatus }) => {
  const { projectid } = useParams();
  const [toggleProjectDetails, setToggleProjectDetails] = useState("overview");
  const { logout, emailVer, userRole, isSidebarCollapsed } = useAuth()
  const navigate = useNavigate()


  const [singleProjectData, setSingleProjectData] = useState('')
  const [singleProjectVulnerability, setSingleProjectVulnerability] = useState([])


  const selectedProjectDetails = async () => {
    try {
      const response = await fetch(`${url}/selectedprojectdetails?projectId=${projectid}`, {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        }
      })
      const data = await response.json()

      setSingleProjectData(data.project)
      setSingleProjectVulnerability(data.vulnerabilityData)
      console.log('status', data.vulnerabilityData)

      if (response.status === 403) {
        logout()
        return
      }

    } catch (error) {
      console.log(error)
    }
  }


  useEffect(() => {
    handleToggle(toggleProjectDetails);
    selectedProjectDetails()
  }, [toggleProjectDetails]);

  const handleToggle = (tab) => {
    return <ProjectTabContent
      tab={tab}
      selectedProjectDetails={selectedProjectDetails}
      singleProjectData={singleProjectData}
      singleProjectVulnerability={singleProjectVulnerability} />;
  };



  return (
    <div className="isecurion-user-table">
      <div>
        <div className='client_navabr1'>
          <ClientNavbar1 />
        </div>
        <div className='isecurion_navbar_second'><IsecNavbar2 singleProjectData={singleProjectData} /></div>
      </div>

      <div className='wrap_isecurion_navbar_usertable'>
        <div className={isSidebarCollapsed ? 'isecuriondash-navbar' : 'isecuriondash_close_navbar'}>
          <IsecNavbar />
        </div>
        <div className={isSidebarCollapsed ? 'wrap_isecurion_dashboard_data_open' : 'wrap_isecurion_dashboard_data'} >
          <div className="isecurion_single_project_container">
            <div className="isecurion_single_project_header_container">

              <ProjectHeader setToggleProjectDetails={setToggleProjectDetails} />

              <div className="isecurion_single_project_header_add_vul">
                <button className='isecurion_add_vul_button'
                  onClick={() =>
                    navigate(`/isecurion_dash/status/${projectid}/addvuln`)
                  }>
                  Add Vulnerability
                </button>
                <div style={{ marginLeft: "20px" }}>
                  <GenerateReportFiles projectId={projectid} />
                </div>
              </div>

            </div>

            <div className="isecurion_single_project_overview_container">
              {handleToggle(toggleProjectDetails)}
            </div>
          </div>
        </div>

      </div >
    </div >
  );
};

const mapStateToProps = (state) => ({
  selectedOption: state.status,
});

const mapDispatchToProps = (dispatch) => ({
  setStatus: (status) => dispatch(changeStatus(status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Status);
